var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_193_37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 11.6C23.5405 11.6 25.6 9.5405 25.6 6.99999C25.6 4.45948 23.5405 2.39999 21 2.39999C18.4595 2.39999 16.4 4.45948 16.4 6.99999C16.4 9.5405 18.4595 11.6 21 11.6Z",
    fill: "white",
    stroke: "#15847B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6 6.99999C12.6 9.58118 10.7258 11.6 8.50002 11.6C6.27425 11.6 4.40002 9.58118 4.40002 6.99999C4.40002 4.4188 6.27425 2.39999 8.50002 2.39999C10.7258 2.39999 12.6 4.4188 12.6 6.99999Z",
    fill: "white",
    stroke: "#15847B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6 21V23.7514C26.1731 25.0521 23.5218 25.6298 20.9146 25.5988C18.3087 25.5679 15.7153 24.9286 12.4 23.7453V21C12.4 16.2504 16.2504 12.4 21 12.4C25.7496 12.4 29.6 16.2503 29.6 21Z",
    fill: "white",
    stroke: "#15847B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6 21V23.7514C14.1731 25.0521 11.5218 25.6298 8.91463 25.5988C6.30868 25.5679 3.71531 24.9286 0.400024 23.7453V21C0.400024 16.2504 4.25037 12.4 9.00002 12.4C13.7496 12.4 17.6 16.2503 17.6 21Z",
    fill: "white",
    stroke: "#15847B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 11.6C17.3167 11.6 19.6 9.31665 19.6 6.49999C19.6 3.68334 17.3167 1.39999 14.5 1.39999C11.6834 1.39999 9.40002 3.68334 9.40002 6.49999C9.40002 9.31665 11.6834 11.6 14.5 11.6Z",
    fill: "white",
    stroke: "#15847B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7592 11.4H15.1512C16.9624 11.4 18.2899 11.4005 19.326 11.5086C20.3552 11.616 21.0511 11.826 21.6147 12.2154C22.0722 12.5314 22.4686 12.9278 22.7846 13.3853C23.174 13.9489 23.384 14.6448 23.4914 15.674C23.5995 16.7101 23.6 18.0376 23.6 19.8488C23.6 22.3849 23.5886 23.5094 23.0032 24.5437C22.8051 24.8936 22.4223 25.3777 22.1275 25.651C21.2518 26.4628 20.4093 26.6712 18.4864 27.1265C15.7271 27.78 13.3119 27.7432 10.6182 27.1016C8.64018 26.6305 7.77172 26.4145 6.91045 25.6337C6.58205 25.336 6.18238 24.8299 5.96886 24.4415C5.41111 23.4268 5.40002 22.2988 5.40002 19.7592C5.40002 17.9909 5.40051 16.6948 5.50379 15.682C5.60639 14.6758 5.80709 13.9936 6.17896 13.4389C6.5128 12.9408 6.9408 12.5128 7.43887 12.1789C7.99367 11.8071 8.67583 11.6064 9.68199 11.5038C10.6948 11.4005 11.9909 11.4 13.7592 11.4Z",
    fill: "white",
    stroke: "#15847B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_193_37"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.2bcd237128f5357ab17cff50363fbee8.svg";
export { ForwardRef as ReactComponent };